import { MotorStatusMdl } from "./MotorStatusMdl";


export class OtpVerifyRes
{
    public IqamaNo:string;
    public Regno:number;
    public token:string;
    public Lng:string;
    public InsuredName:string;
    public InsuredNameAr:string;
    public Nationality: string;
    public  NationalityAr: string;
    public Insuredtoken:string;

    public st:MotorStatusMdl=new MotorStatusMdl();
}




// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/OtpVerifyRes.ts